// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fcfc011f","337":"f8aa0935","453":"6f1c80d8","455":"b48e5fc3"}[chunkId] + ".chunk.js";
};